import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  chip: {
    height: 20,
    fontsize: 10,
    borderRadius: 20,
    marginLeft: 1,
    marginRight: 1,
    '& span': {
      paddingLeft: 6,
      paddingRight: 6,
      fontWeight: 500
    }
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const Markers = ({ markers }) => {
  const classes = useStyles();

  const symbols = [];
  markers.forEach(({ symbol, color, hallow = false, tooltip = null }) => {
    const exists = symbols.find(s => s.symbol === symbol && s.color === color);
    if (!exists) {
      symbols.push({
        symbol,
        color,
        hallow,
        tooltip
      });
    }
  });

  return (
    <div className={classes.container}>
      {symbols.map(({ symbol, color, hallow, tooltip }) => {
        const chip = (
          <Chip
            key={`${symbol}-${color}-${hallow ? 'hallow' : 'normal'}`}
            label={symbol}
            className={classes.chip}
            style={
              hallow
                ? {
                    backgroundColor: 'transparent',
                    border: `1px solid #${color}`,
                    color: `#${color}`
                  }
                : {
                    backgroundColor: `#${color}`,
                    color: 'white'
                  }
            }
          />
        );
        if (tooltip) {
          return (
            <Tooltip title={tooltip} placement="right-end">
              {chip}
            </Tooltip>
          );
        }
        return chip;
      })}
    </div>
  );
};

Markers.propTypes = {
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      symbol: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      field: PropTypes.number,
      option: PropTypes.number
    })
  ).isRequired
};

export default Markers;
